import styled from "styled-components";

export const SectionWrap = styled.section`
    //padding-block: 100px;
    padding-block-start:100px;
    padding-block-end:90px;
`;
